import { VStack } from '@revolut-internal/ui-kit'

import { usePrompt } from '../../providers/PromptProvider'
import { CollapsibleSection } from './CollapsibleSection'
import { DEBUG_ACTION_NAME } from './consts'
import { mapTransactionsData } from './mapTransactionsData'
import { PromptTransactionsContext } from './PromptTransactionsContext'
import { TraceAction } from './TraceAction'

export const Trace = () => {
  const { selectedProcessData, isLoading } = usePrompt()

  if (isLoading || !selectedProcessData?.traces?.length) {
    return null
  }

  return (
    <VStack p="s-8" width="100%" height="100%" overflow="auto">
      {selectedProcessData.traces.map(action => (
        <CollapsibleSection
          key={action.id}
          name={`${action.name} (${action.duration}s)`}
          initialOpen={action.name === DEBUG_ACTION_NAME}
        >
          <PromptTransactionsContext.Provider
            value={
              action.name === DEBUG_ACTION_NAME
                ? mapTransactionsData(selectedProcessData)
                : undefined
            }
          >
            <TraceAction {...action} />
          </PromptTransactionsContext.Provider>
        </CollapsibleSection>
      ))}
    </VStack>
  )
}
